module.exports = __webpack_public_path__ + "static/media/angus_docs.4f7bac71.wav";